import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

const CircleCDTicker = ({progress, onComplete, colorCirlce}) => {

    return (
        <div className="circle-countdown m-auto">
            <CountdownCircleTimer className="m-auto"
                size={80}
                isPlaying
                duration={100}
                onComplete = {onComplete}
                colors={colorCirlce}
            >
            {({ remainingTime }) => remainingTime}
            {/* {progress} */}
            </CountdownCircleTimer>
        </div>
    )
}


export default CircleCDTicker